<template lang="html">

  <div class="pippo slds-scrollable">
    <table class="slds-table slds-table_cell-buffer slds-table_bordered slds-table_col-bordered slds-table_striped">

      <thead>
        <tr class="slds-line-height_reset">
          <th class="bloccato slds-is-sortable" 
            v-bind:class="{ 'slds-is-sorted': col.sortdir, 'slds-is-sorted_des': col.sortdir=='desc', 'slds-is-sorted_asc': col.sortdir=='asc' }"
            v-for="(col, index) in cols" scope="col" v-bind:key="col.order" style="vertical-align:top" >
            <a class="slds-th__action slds-text-link_reset" href="#" role="button" tabindex="0">
              <span class="pippo"  v-bind:style=" (wrapheader?'white-space: normal':'') " v-html="col.label" v-on:click="$emit('filter',index)"></span>

              <svg v-if="col.filtered" class="slds-icon slds-icon-text-default slds-icon_x-small" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#filterList"></use>
              </svg>

              <span class="slds-icon_container slds-icon-utility-arrowdown" v-if="col.issortable" v-on:click="$emit('sort',index)">
                <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon " aria-hidden="true">
                 <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#arrowdown"></use>
                </svg>
              </span>
<!--
              <span class="slds-icon_container slds-icon-utility-arrowup" v-if="col.issortable && col.sortasc" v-on:click="$emit('sort',index)">
                <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon " aria-hidden="true">
                 <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#arrowup"></use>
                </svg>
              </span>
              <span class="slds-icon_container slds-icon-utility-arrowdown" v-if="col.issortable  && col.sortdesc" v-on:click="$emit('sort',index)">
                <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon " aria-hidden="true">
                 <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#arrowdown"></use>
                </svg>
              </span>
              -->
            </a>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-on:click="$emit('row',rindex)" v-for="(record, rindex) in records" v-bind:key="record.id" class="slds-hint-parent" style="padding-right:4px;">

          <td v-for="(col,index) in cols" v-bind:key="col.order" v-bind:style="'text-align:'+align(col.type)" v-bind:class="{'slds-truncate': !showTooltip(record, col)}" >

            <a v-if="index==0" v-bind:href="$route.path+'/'+record['Id']" v-on:click.prevent="select(rindex)">
              <div class="slds-truncate" v-bind:style=" (wrapcell ?'white-space: normal':'') " >
                {{record[col.name] | filter(col.type)}}
              </div>
            </a>

            <span v-if="index>0" class="slds-truncate">

              <span v-if="col.type=='alert' && record[col.name]" class="slds-icon_container slds-icon-utility-announcement" v-bind:title="'Alert'">
                <svg class="slds-icon slds-icon-text-default slds-icon_x-small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#alert"></use>
                </svg>
                <span class="slds-assistive-text">Alert</span>
              </span>

              <span v-if="col.type=='camp' " class="slds-icon_container slds-icon-utility-announcement" v-bind:title="'Campagne'">
                <div>
                  <span v-for="(option,index) in col.options" v-bind:key="option" class="camp" 
                    v-bind:class="{'camppari':Math.floor(index/5)%2,'campdispari':!(Math.floor(index/5)%2), 'campsi': campfilter(option, record[col.name]) }">
                    {{option.substr(0,1)}}
                    <span class="campsub">{{option.substr(1,1)}}</span>
                  </span>
                </div>
              </span>

              <span v-if="col.type=='input' " v-bind:style="{ 'font-weight': (record.isbold?'bold':''), 'text-decoration': (record.isbold?'underline':'auto') }">
                <input v-bind:disabled="record['forecastdisabled']" type="checkbox" v-bind:checked="getFieldValue(record,col.name)<0" v-on:change="$emit('change', { index: rindex, name: col.name, value: -1} )" />  
                <!-- &nbsp;
                <input v-bind:disabled="record['forecastdisabled']" type="number" v-if="!(getFieldValue(record,col.name)<0)" v-bind:value="getFieldValue(record,col.name)" v-on:change="$emit('change', { index: rindex, name: col.name, value: $event.target.value} )"  style="text-align: right; width:80px" min="0"/>
                -->
                <span v-if="getFieldValue(record,col.name)<0"> NO ORDINI</span>
              </span>
              <span v-if="col.type=='input2' " v-bind:style="{ 'font-weight': (record.isbold?'bold':''), 'text-decoration': (record.isbold?'underline':'auto') }">
                <input disabled="true" type="checkbox" v-bind:checked="getFieldValue(record,col.name)" />
                <span v-if="getFieldValue(record,col.name)">Affiliabile</span>
              </span>
              <span v-if="col.type=='input3' " v-bind:style="{ 'font-weight': (record.isbold?'bold':''), 'text-decoration': (record.isbold?'underline':'auto') }">
                <input type="text" maxlength="250" v-bind:value="getFieldValue(record,col.name)" v-on:change="$emit('change', { index: rindex, name: col.name, value: $event.target.value} )" />  
              </span>

              <span v-if="col.type!='camp' && col.type!='input' && col.type!='input2' && col.type!='input3' && col.type!='mix'" v-bind:style="{ 'font-weight': (record.isbold?'bold':''), 'text-decoration': (record.isbold?'underline':'auto') }">
                {{getFieldValue(record,col.name) | filter(col.type) }}
              </span>
              
              <span v-if="col.type=='mix'" :style="{ 'font-weight': (record.isbold?'bold':''), 'text-decoration': (record.isbold?'underline':'auto') }">
                <span>{{getFieldValue(record,col.name) | filter('string')}}</span>
                <span :style="{ 'float':'right', 'text-decoration': 'underline' }">{{getFieldValue(record,col.value) | filter('currency')}}</span>
              </span>
              
            </span>

            <div v-on:click="requestTooltipData(record, col.name)" class="xxxx_tooltip" style="font-size: 13px; display: inline;">
              <tooltip
                v-if="showTooltip(record, col)"
                
                v-bind:label="'test'"
                v-bind:icon="'info'"
                v-bind:iconFamily="'utility'"
              style="display: inline;"
              >
              <div v-if="typeof getTooltipValue(record.Id, col.name) !== 'string'" >
                <div v-for="oggetti in getTooltipValue(record.Id, col.name)" class="tooltipValue">
                  <p v-for="riga in oggetti" style="margin-bottom: 3px;"><b>{{riga.label}}:</b> {{ riga.value }}</p>
                  <!-- <p >Numero: {{fattura.Name}}</p>
                  <p >Data: {{fattura.Data_fattura_2__c}}</p>
                  <p >Quantità: {{fattura.Quantita__c}}</p> -->

                </div>
                <div v-if="getTooltipValue(record.Id, col.name).length < 1"> Nessuna fattura associata</div>
              </div>
              <div v-else>
                recupero dati...
              </div>
              
              
         
              </tooltip>
            </div>
          </td>

        </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
/*
  cols
    label
    order
    name
    type
  records
    name
*/

import numeral from 'numeral'
import moment from 'moment'
import tooltip from '../components/tooltip.vue';

export default {
  name: 'gnetTable',
  components: {
    tooltip
  },
  props: {
    wrapheader: Boolean,
    wrapcell: Boolean,
    cols: Array,
    records: Array,
    tooltipsValue: Object,
  },
  data: function () {
    return {
      localTooltips: {...this.tooltipsValue} 
    }
  },
  watch: {
    tooltipsValue: {
      handler(newVal) {
        this.localTooltips = {...newVal};
      },
      deep: true
    }
  },
  computed: {
    // sTooltipsValue(){
    //   console.log("intercettato cambiamento", this.tooltipsValue)
    //   return this.tooltipsValue
    // },
    reactiveTooltips() {
      return {...this.localTooltips};
    }
  },
  mounted: function() {
  },
  filters: {
    filter: function(v, type) {
      switch(type) {
        case 'date':
          if (v) {
            var n=new moment(v);
            return n.format('DD/MM/YYYY');
          }
          return v;
        case 'decimal':
          if (v)
            return numeral(v).format('0,0');
          return v;
        case 'currency':
          if (v)
            return numeral(v).format('$ 0,0.00');
          return v;
        case 'alert':
            if (!v)
              return '';
            return '';
        case 'truncate':
          if (v)
            return v.substr(0,32);
      }
      return v;
    }
  },
  methods: {
    getTooltipValue(recordId, colName) {
      const key = recordId + "-" + colName;
      return this.reactiveTooltips[key] || 'Caricamento...';
    },
    requestTooltipData(record, colName){
      console.log(record.Id, colName, "richiesta tooltip")
      const key = record.Id+"-"+colName;
      const datiDoc = {
        key: key,
        record: record,
      }
       this.$emit('requestTooltipData', datiDoc);

    },
    showTooltip: function(record, col){
      if(!record.tooltips || !record.tooltips.length > 0) {

        // console.log("il contrario: ", record, col)
        return;}
      const rightCol = record.tooltips.find(tooltip => tooltip.column == col.name) 

      //const isTheConditionTrue;
    
      if(!rightCol) return false;

      // console.log("start data: ", record, col)
      // console.log("col found: ", rightCol)


      let tFormula = rightCol.formula;
      if(tFormula.operator == "=="){
        // console.log("tento controllo", record, tFormula.field, tFormula.value)
        // if(record[tFormula.field]) console.log("VALORE ROTTO: ", record[tFormula.field])
        return record[tFormula.field] == tFormula.value;
      }
      // console.log("operatore non previsto: ", tFormula.operator)
      
      return true;

    },
    campfilter: function(campagna, val) {
      if (!val || !campagna) return false;
      /*
      if (val.includes("2020PW") && campagna=='P2') return true;
      if (val.includes("2020SC") && campagna=='S2') return true;
      if (val.includes("2020NA") && campagna=='N2') return true;
      if (val.includes("2020RE") && campagna=='R2') return true;
      if (val.includes("2020MO") && campagna=='M2') return true;

      if (val.includes("2021PW") && campagna=='P1') return true;
      if (val.includes("2021SC") && campagna=='S1') return true;
      if (val.includes("2021NA") && campagna=='N1') return true;
      if (val.includes("2021RE") && campagna=='R1') return true;
      if (val.includes("2021MO") && campagna=='M1') return true;
      */

      if (val.includes("2024PW") && campagna=='P2') return true;
      if (val.includes("2024SC") && campagna=='S2') return true;
      if (val.includes("2024NA") && campagna=='N2') return true;
      if (val.includes("2024RE") && campagna=='R2') return true;
      if (val.includes("2024MO") && campagna=='M2') return true;

      if (val.includes("2025PW") && campagna=='P1') return true;
      if (val.includes("2025SC") && campagna=='S1') return true;
      if (val.includes("2025NA") && campagna=='N1') return true;
      if (val.includes("2025RE") && campagna=='R1') return true;
      if (val.includes("2025MO") && campagna=='M1') return true;

      if (val.includes("2026PW") && campagna=='PW') return true;
      if (val.includes("2026SC") && campagna=='SC') return true;
      if (val.includes("2026NA") && campagna=='NA') return true;
      if (val.includes("2026RE") && campagna=='RE') return true;
      if (val.includes("2026MO") && campagna=='MO') return true;
    },
    fireCamp: function(colname, record, option) {
      var v=record[colname];
      console.log('v='+v+' o='+option);
      var x='';
      if (!v) { 
        x=option+'SI';
      } else {
        if (!v.includes(option+'SI') && !v.includes(option+'NO')) x=option+'SI';
        if (v.includes(option+'SI')) x=option+'NO';
        if (v.includes(option+'NO')) x=option;
      }
      this.$emit('change', { record: record, name: colname, value:x });
    },
    campStatus: function(option, v) {
      if (v && v.includes(option)) {
        if (v.includes(option+'SI')) {
          return 'campsi';
        }
        if (v.includes(option+'NO')) {
          return 'campno';
        }
      }
      return '';
    },
    getFieldValue: function(obj, path) {
      // eslint-disable-next-line no-redeclare
      for (var i=0, path=path.split('.'), len=path.length; i<len; i++){
        if (obj)
          obj = obj[path[i]];
      }
      return obj;
    },
    align: function(type) {
      switch(type) {
        case 'currency':
        case 'decimal':
          return 'right';
      }
      return 'left';
    },
    select: function(index) {
      console.log('record select');
      this.$emit('click', this.records[index]);
    },
  }
}
</script>

<style scoped>
.bloccato {
  position: sticky;
  top: 0;
  z-index: 1;
}
.camp {
  width: 22px;
  height: 20px;
    margin-right: 0px;
    padding-left: 2px;
    padding-right: 0px;
    padding-bottom: 2px;  
}

.campdispari {
  border-top: 1px solid gray;
}
.camppari {
  border-bottom: 1px solid gray;
}

.campsub {
  vertical-align: sub;
  font-size: smaller;  
  display: none;
}
.campno {
  background-color:#ba0517;
  color: white;
}
.campsi {
  background-color:#45c65a;
  color:#080707;
}
.pippo.slds-scrollable {
  max-height: 80vh; /* O qualsiasi altezza desideri */
}
.bloccato {
  position: sticky;
  top: 0;
  z-index: 10; /* Assicurati che sia sopra le celle */
  background-color: #f3f2f2; /* Colore di sfondo SLDS per header */
  vertical-align: top !important;
}
thead tr {
  position: sticky;
  top: 0;
  z-index: 10; /* Sopra al corpo della tabella */
}

.tooltip{
  position: absolute;
  right: 0px;
  top: -5px;
  scale: 80%;
  overflow: visible;
  z-index: 9;

}

.tooltipValue:not(:last-child) {
  border-bottom: 1px solid black;
}
</style>
